import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { faUsers, faCheck, faIdCard, faTimes } from '@fortawesome/free-solid-svg-icons';
import ListPageHeader from '../../common/lists/ListPageHeader';
import { getAllProspects, approveWorkerProspect, checkWorkerProspect, callbackWorkerProspect, convertWorkerProspect } from '../../../actions/prospects';
import qs, { stringify } from 'qs';
import PaginationBaseComponent from '../../common/PaginationBaseComponent';
import { USERS_LIST_PAGE_SIZE } from '../../../constants/general';
import _ from 'lodash';
import { prospectStatuses } from '../../../constants/prospects';
import ListItem from '../../common/lists/ListItem';
import { defaultUserPhoto } from '../../../constants/ui';
import { UIShowConfirm } from '../../../actions/ui';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import styled from 'styled-components';
import Close from '../../common/ui/Close';
import { getSelectedFilterValuesForUI } from '../../../helpers/general';

import DenyProspectModal from './DenyProspectModal';
import EmptyListUi from './EmptyListUi';
import SelectOrientationModal from './SelectOrientationModal';
import { getDateWithOffset } from '../../../helpers/timezones';

import moment from 'moment';

const StatusButtons = styled.div`
  margin-bottom: 20px !important;
`;

const tabs = {
  verified: {
    id: 'verified',
    ui: 'Scheduled'
  },
  background: {
    id: '',
    ui: 'Background'
  },
  callback: {
    id: 'callback',
    ui: 'Callback'
  },
  approved: {
    id: 'approved',
    ui: 'Approved'
  },
  denied: {
    id: 'denied',
    ui: 'Denied'
  }
};

const Row = styled.div`
  display: block;
`;

const emptyFilter = {
  query: ''
};

const queryObject = qs.parse(window.location.search, { ignoreQueryPrefix: true });
const { query } = queryObject;

class ProspectsList extends PaginationBaseComponent {
  static propTypes = {
    initialData: PropTypes.array.isRequired,
    pagesQuantity: PropTypes.number.isRequired,
    getDataAction: PropTypes.func.isRequired,
    header: PropTypes.bool
  }

  static defaultProps = {
    header: true
  }

  constructor (props) {
    super(props);
    this.handleInputChangeDebounce = _.debounce(this._loadData, 500);
  }

  state = {
    isOpen: false,
    shouldShowUnscheduled: false,
    shouldShowScheduled: true,
    orientationIsOpen: false,
    activePage: this.getActivePage(),
    selectedTab: tabs.verified.id,
    background_status: '',
    orientation_id: this.props.orientation_id || '',
    query,
    appliedFilterParams: getSelectedFilterValuesForUI(qs.parse(window.location.search, { ignoreQueryPrefix: true }), emptyFilter)
  }

  stringifyProspectFilterParams = (filterParams) => {
    const { activePage, background_status, query, selectedTab, orientation_id } = filterParams;

    const filterData = {
      ...orientation_id && { orientation_id },
      ...query && { query },
      ...background_status && { background_status },
      page: activePage + 1,
      ...selectedTab && { [selectedTab]: true }
    };
    const { page, ...urlFilterData } = filterData;
    const queryString = `&${stringify(filterData)}`;
    const urlString = `&${stringify(urlFilterData)}`;
    return { queryString, urlString };
  }

  componentDidMount () {
    this._loadData(this.state.activePage);
  }

  _loadData = (activePage = this.state.activePage) => (
    this.loadData(activePage, this.stringifyProspectFilterParams(this.state))
  )

  switchTab = event => {
    this.setState({
      query: '',
      activePage: 0,
      selectedTab: event.target.id,
      background_status: event.target.id === '' ? 'pending' : ''
    }, this._loadData);
  }

  showUnscheduled= () => {
    this.setState(state => ({
      shouldShowUnscheduled: !state.shouldShowUnscheduled
    }));
  }

  showScheduled= () => {
    this.setState(state => ({
      shouldShowScheduled: !state.shouldShowScheduled
    }));
  }

  switchStatus = event => this.setState({ background_status: event.target.value }, this._loadData)

  pageSize = USERS_LIST_PAGE_SIZE;

  approveProspect = (prospect) => {
    const { approveWorkerProspect, UIShowConfirm } = this.props;

    UIShowConfirm('Are you sure you want to approve the candidate?', () =>
      approveWorkerProspect({ id: prospect.id })
        .then(res => console.log(res))
        .then(res => console.log(`Sending browser to worker user_id: ${res.data.prospect.user_id}`))
        .then(res => this.props.history.push(`/app/workers/${res.data.prospect.user_id}`)));
  }

  checkProspect = (prospect) => {
    const { checkWorkerProspect, UIShowConfirm } = this.props;

    UIShowConfirm('Are you sure you want to start background check for the candidate?', () =>
        checkWorkerProspect({ id: prospect.id }).then(res => console.log(res)));
  }

  callbackProspect = (prospect) => {
    const { callbackWorkerProspect, UIShowConfirm } = this.props;

    UIShowConfirm('Are you sure you want to move prospect into Callback status?', () =>
      callbackWorkerProspect({ id: prospect.id }));
  }

  convertProspect = (prospect) => {
    const { convertWorkerProspect, UIShowConfirm } = this.props;

    UIShowConfirm('Are you sure you want to move prospect into Gravy interview process?', () =>
        convertWorkerProspect({ id: prospect.id })
          .then(res => {
            this.props.history.push(`/app/workers/${res.data.prospect.user_id}`);
          })
          .catch(error => console.log(error)));
  }

  undecided = (prospect) => !prospect.approved && !prospect.denied

  approvalPage = (selectedTab) => selectedTab === '' || selectedTab === 'verified'

  applyFilter = () => {
    const { query } = this.state;
    this.setState({
      appliedFilterParams: getSelectedFilterValuesForUI(query, emptyFilter)
    });
    this._loadData();
  };

  handleClearFilterParam = () => {
    this.handleChange('').then(this.applyFilter);
  };

  handleChange = async (value) => this.setState({ query: value });

  handleInputChange = event => this.handleChange(event.target.value).then(this.handleInputChangeDebounce);

  getOrientationDate = (orientation) => {
    const { start_date } = orientation;
    const formattedDate = moment.utc(start_date).format('MM/DD/YYYY');
    return formattedDate;
  }

  render () {
    const { header, initialData, pagesQuantity } = this.props;
    const { orientationIsOpen, selectedProspect, isOpen, selectedTab, background_status, query,
            shouldShowScheduled, shouldShowUnscheduled } = this.state;

    return (
      <div className='job-list-wrapper'>
        <SelectOrientationModal
          isOpen={orientationIsOpen}
          prospect={selectedProspect}
          closeModal={() => this.setState({ orientationIsOpen: false })}
        />

        {header && <ListPageHeader icon={faUsers} title='Prospects' />}

        <div className='filter-params d-flex flex-wrap mb-3'>
          <div className='position-relative align-self-center col-12 mb-3 mb-md-0 col-md-9 p-0'>
            {!!query && (
              <Close onClick={() => this.handleClearFilterParam()} className='button-clear' />
            )}

            <input
              className='input'
              name='query'
              value={query || ''}
              onChange={this.handleInputChange}
              placeholder='Type full name, email or phone number'
            />
          </div>
        </div>

        <div className='tabs-wrapper'>
          {Object.keys(tabs).map(tab => (
            <button
              key={tabs[tab].id}
              id={tabs[tab].id}
              className={selectedTab === tabs[tab].id ? 'tab active' : 'tab'}
              onClick={this.switchTab}
            >
              {tabs[tab].ui}
            </button>
          ))}
        </div>

        {selectedTab === '' &&
          <StatusButtons className='status-filter-buttons'>
            {prospectStatuses.map(({ id, value }) => (
              <button
                key={id}
                value={id}
                className={`filter-button ${background_status === id && 'active'}`}
                children={value}
                onClick={this.switchStatus}
              />
            ))}
          </StatusButtons>
        }
        <div className='inner-tabs-wrapper'>
          {shouldShowUnscheduled &&
          <div
            className='other-button warning-btn mr-2'
            onClick={this.showUnscheduled}
          >
            Hide Unscheduled
          </div>
          }
          {!shouldShowUnscheduled &&
          <div
            className='other-button ok-btn mr-2'
            onClick={this.showUnscheduled}
          >
            Show Unscheduled
          </div>
          }
          {shouldShowScheduled &&
          <div
            className='other-button warning-btn'
            onClick={this.showScheduled}
          >
            Hide Scheduled
          </div>
          }
          {!shouldShowScheduled &&
          <div
            className='other-button ok-btn'
            onClick={this.showScheduled}
          >
            Show Scheduled
          </div>
          }
        </div>
        <div className='list'>
          {initialData && initialData.length > 0 ? initialData.map(prospect => (
            <div>
              {( (prospect.orientation && shouldShowScheduled) || (!prospect.orientation && shouldShowUnscheduled) ) &&
                  <ListItem key={prospect.id} link={prospect.user && `workers/${prospect.user.id}`}>
                    <div className='col d-flex align-items-center col-sm-6'>
                      <div style={{ backgroundImage: `url('${defaultUserPhoto}')` }} className='avatar-sm'/>
                      <div className='text-ellipsis mr-4'>
                        <Row><span
                          className='font-weight-bold'>{prospect.first_name} {prospect.last_name}</span> ({prospect.email})</Row>
                        <Row>{prospect.address} {prospect.address2} {prospect.city}, {prospect.state} {prospect.zip}</Row>
                        <Row>{prospect.phone_number}</Row>
                        <Row>
                          Scheduled Call:&nbsp;
                          <button
                            onClick={() => this.setState({ selectedProspect: prospect, orientationIsOpen: true })}
                            className='button-clean button-link'
                          >
                            {prospect.orientation ? this.getOrientationDate(prospect.orientation) : 'Select Time for Call'}
                          </button>
                        </Row>
                        {prospect.callback_at &&
                        <Row>
                          <span className='font-italic'>Moved To Callback: </span>
                          {getDateWithOffset(prospect.callback_at).format('MM/DD/YYYY h:mm a')}
                        </Row>
                        }
                      </div>
                      {prospect.skills && prospect.skills.map(skill => (
                        <div className='skill-icon has-tooltip' style={{ backgroundImage: `url('${skill.icon_url}')` }}
                             key={skill.id}>
                          <div className='ui-tooltip text-md'>
                            {skill.reference_title}
                          </div>
                        </div>
                      ))}
                    </div>
                    <div className='col d-flex align-items-center justify-content-end col-sm-6 text-md-right'>
                      {prospect.approved && this.approvalPage(selectedTab) &&
                      <div className='d-flex align-items-center ml-auto'>
                        <FontAwesomeIcon className='mr-2' icon={faCheck}/> Approved
                      </div>
                      }
                      {prospect.denied && this.approvalPage(selectedTab) &&
                      <div className='d-flex align-items-center ml-auto'>
                        <FontAwesomeIcon className='mr-2' icon={faTimes}/> Denied
                      </div>
                      }
                      {this.undecided(prospect) && selectedTab === 'verified' && prospect.checkr_status &&
                      <div className='d-flex align-items-center ml-auto'>
                        <FontAwesomeIcon className='mr-2' icon={faIdCard}/> In Check
                      </div>
                      }
                      {this.undecided(prospect) && this.approvalPage(selectedTab) &&
                      <Fragment>
                        <button
                          onClick={() => this.convertProspect(prospect)}
                          className='button button-primary ml-4'
                        >
                          Start Interview
                        </button>
                        <button
                          onClick={() => this.callbackProspect(prospect)}
                          className='button button-warning ml-4'
                        >
                          Callback
                        </button>
                        <button
                          onClick={() => this.setState({ selectedProspect: prospect, isOpen: true })}
                          className='button button-delete ml-4'
                        >
                          Deny
                        </button>
                        {selectedTab === '' &&
                        <button
                          onClick={() => this.approveProspect(prospect)}
                          className='button button-primary ml-4'
                        >
                          Approve
                        </button>
                        }
                      </Fragment>
                      }
                      {selectedTab === 'denied' &&
                      <div className='d-flex align-items-center ml-auto'>
                        {prospect.denied && prospect.deny_reason}
                      </div>
                      }
                    </div>
                  </ListItem>
              }
            </div>
          ))
          : <EmptyListUi />
          }
        </div>

        <DenyProspectModal
          prospect={selectedProspect}
          isOpen={isOpen}
          closeModal={() => this.setState({ isOpen: false })}
        />

        {pagesQuantity > 1 && this.renderPagination()}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    initialData: state.prospects.prospectsList,
    pagesQuantity: state.prospects.pagesQuantity
  };
};

const mapDispatchToProps = {
  approveWorkerProspect,
  checkWorkerProspect,
  convertWorkerProspect,
  callbackWorkerProspect,
  getDataAction: getAllProspects,
  UIShowConfirm
};

export default connect(mapStateToProps, mapDispatchToProps)(ProspectsList);



// WEBPACK FOOTER //
// ./src/components/app/prospectsList/index.js